import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const Stats = () => {
  const user = useSelector((state) => state.user.data);
  const wishDates = user?.wishDates || [];
  const [noOfUsers, setNoOfUsers] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNoOfUsers = async () => {
      try {
        const response = await fetch('https://api-wish3s.vercel.app/data/noofusers');
        const data = await response.json();
        setNoOfUsers(data.count);
      } catch (error) {
        console.error('Failed to fetch number of users:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchNoOfUsers();
  }, []);

  const renderProgressCircle = (percentage, label, color) => {
    const radius = 90;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (percentage / 100) * circumference;

    return (
      <div className="relative w-64 h-64 bg-white shadow-lg rounded-full flex items-center justify-center">
        <svg
          className="absolute top-0 left-0 w-full h-full"
          viewBox="0 0 200 200"
        >
          <circle
            cx="100"
            cy="100"
            r={radius}
            fill="none"
            stroke="#e5e7eb"
            strokeWidth="9"
          />
          <circle
            cx="100"
            cy="100"
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth="9"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
          />
        </svg>
        <div className="text-center">
          <p className="text-4xl font-bold" style={{ color }}>{Math.round(percentage)}%</p>
          <p className="text-gray-600">{label}</p>
        </div>
      </div>
    );
  };

  if (wishDates.length === 0) {
    return (
      <div className="w-80 p-6 bg-white/30 backdrop-blur-md rounded-lg shadow-lg text-center">
        <p className="text-xl font-semibold text-gray-700">Make a Wish!</p>
        <p className="text-gray-500">Add a wish date to start tracking your stats.</p>
      </div>
    );
  } else {
    const startDate = new Date(wishDates[0]);
    const currentDate = new Date();

    const totalDays = Math.ceil(
      (currentDate - startDate) / (1000 * 60 * 60 * 24)
    );

    const wishPercentage = totalDays > 0 ? (wishDates.length / totalDays) * 100 : 100;

    const userChangePercentage = noOfUsers ? (1 / noOfUsers) * 100 : 0;

    return (
      <div className="flex flex-col items-center justify-center min-h-screen space-y-8 bg-gray-100 mt-19">
        <h1>stats</h1>
        {renderProgressCircle(wishPercentage, 'of days wished', '#ff0000')}
        {loading ? (
          <p>Loading user data...</p>
        ) : noOfUsers !== null ? (
          renderProgressCircle(userChangePercentage, 'your chances', '#ff0000')
        ) : (
          <p className="text-red-500">Failed to load user data</p>
        )}
      </div>
    );
  }
};

export default Stats;
